import styled from 'styled-components/macro';
import { StandardBottomMargin, StandardSideMargin } from '../../../../shared-styles';

export const Container = styled.div`
  ${StandardSideMargin}
  ${StandardBottomMargin}
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
`;
